import { SuccessStatus } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const updateUser = (req: any): Promise<SuccessStatus> =>
  request({
    url: '/service/userv2service/UpdateUser',
    body: req,
  }).then((r) => r.body);
